module.exports = "https://cdn.thelire.com/ins/resource/pic_friendlyreminder_android@3x.6f07573565e4571d08a8772fe4797e24.png";